var map = {
	"./de/triangleIcon.png": "hWd0",
	"./en/triangleIcon.png": "O3E2",
	"./es/triangleIcon.png": "fOje",
	"./fr/triangleIcon.png": "Y/6v",
	"./ja/triangleIcon.png": "dhYq",
	"./ko/triangleIcon.png": "7NLj",
	"./pt/triangleIcon.png": "vbbh",
	"./ru/triangleIcon.png": "jSom",
	"./tc/triangleIcon.png": "cE5m",
	"./th/triangleIcon.png": "zMqp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "iAPk";